import { EmployeeOrderEditComponent } from './../employee-order-edit/employee-order-edit.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatSort } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { RouteVehicleEditComponent } from '../route/route-vehicle-edit/route-vehicle-edit.component';


@Component({
  selector: 'app-employee-order',
  templateUrl: './employee-order.component.html',
  styleUrls: ['./employee-order.component.scss']
})
export class EmployeeOrderComponent implements OnInit {

  title: any;
  customer_type_id: any;
  month: any;
  year: any;
  today_date: any;
  employee_list:any;
  employee_order_list: any;
  filtered_employee_list:any;
  customer_type_list = [{ "name": "Employee", "customer_type_id": 3 }, { "name": "Ex-Employee", "customer_type_id": 2 }]
  selected_business_id: any;
  search_term: any;
  is_disabled = false;
  is_disabled_get = false;
  this_order_is_placed = null;
  worning_content: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  is_loaded = true;
  next_month: any;
  next_year: any;
  monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

  constructor(private global: GlobalService, private http: HttpService, private dialog: MatDialog) {
    this.title = this.global._active_display_name;
    this.getCurrentDate();
  }

  getClicked() {
    this.is_disabled = false;
    let data_dict = {
      'employee_id': this.customer_type_id,
      'month': this.month,
      'year': this.year
    }
    this.http.getEmployeeLastOrderList(data_dict).subscribe((data) => {
      this.this_order_is_placed = data['order_status']
      if (this.this_order_is_placed == false) {
        this.employee_order_list = data['employee_order_dict'];
      } else {
        this.worning_content = data['content']
      }
      console.log(data);
    }, (error) => {
      return "Some error occured";
    });
  }

  async getCurrentDate() {
    this.today_date = await this.http.getCurrentDate();
    this.month = new Date(this.today_date).getMonth() + 1;
    this.year = new Date(this.today_date).getFullYear();
    console.log(this.today_date);
    console.log(this.month);
    console.log(this.year);
    if(this.month != 12) {
      this.next_month = this.month;
      this.next_year = this.year
    }
    else {
      this.next_month = 0;
      this.next_year = this.year +1;
    }
    console.log(this.month);
  }

  searchEmployeeCalled(search_term) {
    console.log(search_term);
    if (this.search_term == null || this.search_term === '') {
      this.filtered_employee_list = [];
    } else {
      this.filtered_employee_list = this.employee_list.filter((element) => {
        return element.employee_name.toLowerCase().indexOf(search_term.toLowerCase()) > -1 || element.employee_code.toLowerCase().indexOf(search_term.toLowerCase()) > -1;
      });
    }
  }

  openDialog(edit_field, index, employee_order): void {
    console.log('dialog open');
    const dialogRef = this.dialog.open(EmployeeOrderEditComponent, {
      height: '250px',
      width: '665px',
      data: {
        'input': edit_field,
        'employee_order': employee_order,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      this.employee_order_list[index][edit_field] = res['value'];
      console.log(this.employee_order_list[index])
    });
  }

  orderClicked() {
    // alert("If you want to place this order")
    if(confirm('Are you sure to order ?')){
      this.is_loaded = false;
      this.is_disabled = true;
      this.is_disabled_get = true;
      let data_dict = {
        'customer_type_id': this.customer_type_id,
        'employee_order_list': this.employee_order_list
      }
      this.http.placeEmployeeOrder(data_dict).subscribe((data) => {
        if(data == true){
          this.is_loaded = true;
          alert("Order placed Successfuly");
          this.this_order_is_placed = true;
          this.is_disabled_get = false;
        }
      }, (error) => {
        return "Some error occured";
      });
    }
  }

  removeItem(index){
    this.employee_order_list.splice(index, 1);
  }

  ngOnInit() {
  }

}
